/* eslint-disable max-len */

import React from 'react';
import { connect } from 'react-redux';

import { withGilt, withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import RebookingTableContainer from 'reports/BookingsReport/RebookingTable';
import HeaderMenu from 'reports/Common/HeaderMenu';
import ReportsMainLayoutContainer from 'reports/Common/ReportsMainLayout';
import ReportTableContainer from 'reports/Common/ReportTable';
import { Tables } from 'reports/consts';
import { convertOriginGroupAppointmentsToTable, convertStatusGroupAppointmentsToTable, convertUtmGroupAppointmentsToTable } from 'reports/utils';

const ReportsProps = ['appointmentsReport', 'rebookingReport'];

class BookingsLayout extends ReportsMainLayoutContainer {
  constructor(props) {
    super(props);
    this.state = {
      headerData: {
        name: props.t('businessReports.bookings.title'),
        items: [
          {
            id: Tables.BookingsByOrigin,
            name: props.t('businessReports.bookings.byOrigin'),
            onClick: () => {
              this.setTables(Tables.BookingsByOrigin);
            },
          },
          {
            id: Tables.BookingsByStatus,
            name: props.t('businessReports.bookings.byStatus'),
            onClick: () => {
              this.setTables(Tables.BookingsByStatus);
            },
          },
        ],
      },
      title: '',
      shownTables: 0,
    };
  }

  UNSAFE_componentWillMount() {
    this.setTables(Tables.BookingsByOrigin);
  }

  checkIfAllDataIsLoaded = () => ReportsProps.every((prop) => this.props[prop].lastRequestResponse);

  render() {
    const { uniqueVisitsReport, t, currency: currencyAbbr, formatDate } = this.props;

    return (
      <div className="has-protipbox bookings">
        <div className="new-wraper">
          {!this.checkIfAllDataIsLoaded() && (
            <div className="spinner-container">
              <div className="load-spinner" />
            </div>
          )}
          <HeaderMenu data={this.state.headerData} selectedId={this.state.shownTables} />
          {this.checkIfAllDataIsLoaded() && (
            <div className="box">
              <div className="title">{`${this.state.title}`}</div>
              {!!(this.state.shownTables & Tables.BookingsByOrigin) && (
                <div id="bookings-by-origin">
                  <ReportTableContainer
                    withBoldFooter
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    title={t('businessReports.bookings.bookingsByOriginTableTitle')}
                    data={{
                      rows: convertOriginGroupAppointmentsToTable(this.props.appointmentsReport.lastRequestResponse.origin_group, currencyAbbr, t),
                    }}
                  />
                </div>
              )}
              {!!(this.state.shownTables & Tables.BookingsByOrigin) && (
                <div id="online-bookings-by-origin">
                  <ReportTableContainer
                    withBoldFooter
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    title={t('businessReports.bookings.onlineBookingsByOriginTableTitle')}
                    data={{
                      rows: convertUtmGroupAppointmentsToTable(this.props.appointmentsReport.lastRequestResponse.utm_group, t),
                    }}
                  />
                </div>
              )}
              {this.props.appointmentsReport.lastRequestResponse && !!(this.state.shownTables & Tables.BookingsByStatus) && (
                <div id="bookings-by-status">
                  <ReportTableContainer
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    title={t('businessReports.bookings.bookingsByStatusTableTitle')}
                    data={{
                      rows: convertStatusGroupAppointmentsToTable(this.props.appointmentsReport.lastRequestResponse.status_group, currencyAbbr, t),
                    }}
                  />
                </div>
              )}
              {this.props.rebookingReport.lastRequestResponse && !!(this.state.shownTables & Tables.RebookingRate) && (
                <div className="box">
                  <div className="title">{`${this.state.title}`}</div>
                  <RebookingTableContainer
                    startDate={formatDate(uniqueVisitsReport.start_date, { hideTime: true, hideWeekday: true })}
                    endDate={formatDate(uniqueVisitsReport.end_date, { hideTime: true, hideWeekday: true })}
                    data={this.props.rebookingReport.lastRequestResponse}
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    currentSalon: { id: salonId, stylistList },
    reports,
  } = state;
  const { uniqueVisitsReport, appointmentsReport, rebookingReport, salonVatRate, isFetching } = reports;
  const currency = selectCurrentSalonCurrency(state);

  return {
    uniqueVisitsReport,
    salonId,
    stylistList,
    appointmentsReport,
    rebookingReport,
    salonVatRate,
    isFetching,
    currency,
  };
};

const BookingsLayoutHoc = connect(mapStateToProps)(withGilt(withTranslation()(BookingsLayout)));

export default BookingsLayoutHoc;
